import React from "react";
import { Link as BaseLink, LinkProps as BaseLinkProps } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import { grey, blue } from "@material-ui/core/colors";

const useStyles = makeStyles({
  link: {
    "&:any-link": {
      color: grey[900],
      textDecoration: "none",
      borderBottom: `1px dotted ${grey[900]}`,
      paddingBottom: "1px",
    },
    "&:hover": {
      color: blue[500],
      textDecoration: "none",
      borderBottom: `1px dotted ${blue[500]}`,
      paddingBottom: "1px",
    },
  },
});

export default ({ className, ...props }: BaseLinkProps) => {
  const styles = useStyles();
  return <BaseLink className={[styles.link, className].join(" ")} {...props} />;
};
